import styled from 'styled-components';
import { primary, neutral } from '../../../style/colors';

const Title = styled.h3`
  text-align: left;
  margin: 0 0 16px 0;
  font-size: 15px;
  font-weight: 600;
  color: ${neutral[800]};
  letter-spacing: -0.1px;
  text-transform: uppercase;
  position: relative;
  padding-bottom: 12px;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 32px;
    height: 2px;
    background-color: ${primary[500]};
    border-radius: 1px;
  }
`;

export default Title;
